<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
    extends: Line,
    // mixins: [reactiveProp],
    props: ["chartData"],
    data(instance) {
        var self = this;
        return {
            options: {
                elements: {
                    line: {
                        tension: 0.4,
                        borderWidth: 1,
                        borderColor: "rgba(127, 210, 232, 0.55)",
                        fill: false,
                    },
                    point: {
                        pointStyle: "rect",
                        backgroundColor: "#7fd2e8",
                        borderWidth: 2,
                        borderColor: "#7fd2e8",
                        hitRadius: 5,
                        hoverRadius: 5,
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                // beginAtZero: false,
                                suggestedMin: 0,
                                suggestedMax: 100,
                                maxTicksLimit: 50,
                            },
                            gridLines: {
                                display: true,
                                lineWidth: 0.5,
                                color: "rgba(0,0,0, 0.15)",
                            },
                            scaleLabel: {
                                color: "rgba(127, 210, 232, 1)",
                                display: true,
                                labelString: "Variance (%)",
                            },
                        },
                    ],

                    xAxes: [
                        {
                            gridLines: {
                                display: true,
                                lineWidth: 0.5,
                                color: "rgba(0,0,0, 0.15)",
                            },
                            scaleLabel: {
                                color: "rgba(127, 210, 232, 1)",
                                display: true,
                                labelString: "% of Results",
                            },
                            ticks: {
                                //autoSkip: true,
                                maxTicksLimit: 25,
                                maxRotation: 45,
                                minRotation: 45,
                            },
                        },
                    ],
                },

                tooltips: {
                    enabled: true,
                    caretPadding: 6,
                    cornerRadius: 2,
                    titleSpacing: 4,
                    displayColors: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return (
                                Number(tooltipItem.yLabel)
                                    .toFixed(self.decimalPlaces)
                                    .replace(/./g, function (c, i, a) {
                                        return i > 0 &&
                                            c !== "." &&
                                            (a.length - i) % 3 === 0
                                            ? "," + c
                                            : c;
                                    }) + "%"
                            );
                        },
                    },
                },
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 0,
                        bottom: 0,
                    },
                },
                responsive: true,
                maintainAspectRatio: false,
                animation: {
                    duration: 1000,
                },

                legend: {
                    display: true,
                    title: {
                        text: "I am a legend",
                    },
                    legendText: [
                        "Current",
                        "Vs last week/month/year",
                        "% Change",
                    ],
                },
            },
            data: {
                datasets: [
                    {
                        data: this.chartData.data,
                        label: "Variance spread across results",
                    },
                ],
                labels: Object.keys(this.chartData.data),
            },
        };
    },
    mounted() {
        this.renderLineChart();
    },
    methods: {
        renderLineChart: function () {
            //console.log(this.data);
            this.renderChart(this.data, this.options);
        },
    },

    computed: {},
};
</script>
